/*
  product-pro.js — behavioral scripts for the "Product pages - Pro" section
  (sections/product-pro.liquid). Extracted from inline <script> blocks.

  All DOM lookups use the dedicated `.js-pdp-pro` hook on the section
  wrapper (kept separate from the `.product.pdp-pro` styling class so
  restyling can't break behavior). Loaded deferred; every IIFE self-gates
  on its target elements, so it safely no-ops on non-Pro pages.
*/

(function() {
  var proThumbnailInstance = null;
  var thumbnailClickHandlers = [];
  var sliderChangeHandler = null;

  function hideToggleButton() {
    var toggleButton = document.querySelector('.js-pdp-pro .pdp-pro-thumbnail-toggle');
    if (toggleButton) {
      toggleButton.classList.remove('grid-active');
      toggleButton.style.display = 'none';
    }
  }

  function showToggleButton() {
    var toggleButton = document.querySelector('.js-pdp-pro .pdp-pro-thumbnail-toggle');
    if (toggleButton) {
      toggleButton.classList.add('grid-active');
      toggleButton.style.display = 'flex';
    }
  }

  function setupGradient() {
    var outerContainer = document.querySelector('.js-pdp-pro .outer-pdp-thumbnail-slider');
    if (outerContainer) {
      outerContainer.classList.add('grid-active');
      if (!outerContainer.classList.contains('collapsed') && !outerContainer.classList.contains('expanded')) {
        outerContainer.classList.add('collapsed');
      }
    }
  }

  function cleanupProThumbnails() {
    // Remove all click event listeners
    thumbnailClickHandlers.forEach(function(handler) {
      if (handler.element && handler.listener) {
        handler.element.removeEventListener('click', handler.listener);
      }
    });
    thumbnailClickHandlers = [];

    // Remove slider change listener
    if (sliderChangeHandler && window.pdpSlider) {
      window.pdpSlider.off('slideChange', sliderChangeHandler);
      sliderChangeHandler = null;
    }

    // Destroy Swiper instance if it exists
    var thumbnailContainer = document.querySelector('.js-pdp-pro .js__pdp-thumbnail-slider');
    if (thumbnailContainer && thumbnailContainer.swiper) {
      thumbnailContainer.swiper.destroy(true, true);
      thumbnailContainer.swiper = null;
    }

    // Clean up wrapper styles
    if (thumbnailContainer) {
      var wrapper = thumbnailContainer.querySelector('.swiper-wrapper');
      if (wrapper) {
        wrapper.style.transform = '';
        wrapper.style.transition = '';
      }
    }

    // Hide toggle button and remove gradient when grid is not active
    hideToggleButton();

    proThumbnailInstance = null;
    window.proThumbnail = null;
  }

  function initProThumbnails() {
    if (!document.querySelector('.js-pdp-pro')) return;

    // Grid gallery mode replaces the desktop thumbnail-toggle Swiper entirely.
    // Bail without touching anything so the default pdpThumbnail Swiper from
    // _sm-theme.js stays alive — its thumbs:{ swiper: pdpThumbnail } link with
    // pdpSlider is what keeps mobile thumb→main-slide sync working.
    if (document.querySelector('.js-pdp-pro.gallery-layout--grid')) {
      return;
    }

    var isDesktop = window.innerWidth >= 981;
    var thumbnailContainer = document.querySelector('.js-pdp-pro .js__pdp-thumbnail-slider');

    if (!thumbnailContainer || typeof Swiper === 'undefined') {
      setTimeout(initProThumbnails, 100);
      return;
    }

    // IMPORTANT: Only clean up and initialize custom behavior on desktop
    // On mobile, let the default Swiper from _sm-theme.js handle everything
    if (!isDesktop) {
      // Don't interfere with mobile - just hide the toggle button
      hideToggleButton();
      return;
    }

    // Clean up any existing desktop instance first (only runs on desktop now)
    cleanupProThumbnails();

    // Setup gradient BEFORE thumbnails load (ensure it's ready)
    setupGradient();

    // Wait a bit for main Swiper to initialize
    setTimeout(function() {
      // Double-check we're still on desktop after timeout
      if (window.innerWidth < 981) {
        cleanupProThumbnails();
        return;
      }

      // For 2-column grid layout, we'll use CSS Grid for layout
      // and handle interactions manually while keeping Swiper for compatibility
      // Initialize Swiper but disable its layout transforms
      proThumbnailInstance = new Swiper('.js-pdp-pro .js__pdp-thumbnail-slider', {
        slidesPerView: 'auto',
        direction: 'vertical',
        spaceBetween: 0,
        freeMode: false,
        watchSlidesProgress: true,
        clickable: true,
        grabCursor: false, // Disable grab cursor since we're using native scroll
        mousewheel: false, // Use native scrolling instead
        // Disable Swiper's transform-based scrolling
        allowTouchMove: false,
        // Let CSS Grid handle the layout
        autoHeight: false,
        observer: true,
        observeParents: true,
        // Prevent Swiper from applying transforms
        on: {
          init: function() {
            // Disable Swiper's transform on the wrapper
            var wrapper = this.el.querySelector('.swiper-wrapper');
            if (wrapper) {
              wrapper.style.transform = 'none !important';
              wrapper.style.transition = 'none';
            }
          },
          resize: function() {
            // Handle resize within Swiper
            var wrapper = this.el.querySelector('.swiper-wrapper');
            if (wrapper) {
              wrapper.style.transform = 'none !important';
              wrapper.style.transition = 'none';
            }
          },
          slideChange: function() {
            // This won't fire with allowTouchMove: false, but kept for compatibility
          }
        }
      });

      // Store reference for manual control
      window.proThumbnail = proThumbnailInstance;

      // Show toggle button now that grid is active
      showToggleButton();

      // Dispatch event to notify that grid is ready
      if (typeof window.dispatchEvent !== 'undefined') {
        window.dispatchEvent(new CustomEvent('proGridInitialized'));
      }

      // Handle thumbnail clicks manually for grid layout
      var thumbnails = document.querySelectorAll('.js-pdp-pro .pdp-thumbnail .swiper-slide');

      function updateThumbnailActive(index, shouldScroll) {
        thumbnails.forEach(function(t) {
          t.classList.remove('swiper-slide-thumb-active');
        });
        if (thumbnails[index]) {
          thumbnails[index].classList.add('swiper-slide-thumb-active');
          // Scroll thumbnail into view only when triggered by user interaction
          if (shouldScroll) {
            thumbnails[index].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }
      }

      thumbnails.forEach(function(thumb, index) {
        var clickHandler = function(e) {
          e.preventDefault();
          // Each thumbnail maps directly to a slide (1:1 mapping)
          // In a 2-column grid, thumbnails are arranged:
          // Row 1: [0, 1] -> Slides [0, 1]
          // Row 2: [2, 3] -> Slides [2, 3]
          // So thumbnail index = slide index
          var slideIndex = index;
          if (window.pdpSlider) {
            // Use slideToLoop for loop mode, or slideTo for non-loop mode
            if (window.pdpSlider.params.loop) {
              window.pdpSlider.slideToLoop(slideIndex);
            } else {
              window.pdpSlider.slideTo(slideIndex);
            }
          }
          updateThumbnailActive(index, true); // Enable scroll on user click
        };

        thumb.addEventListener('click', clickHandler);
        thumbnailClickHandlers.push({ element: thumb, listener: clickHandler });
      });

      // Sync thumbnail active state when main slider changes
      if (window.pdpSlider) {
        sliderChangeHandler = function() {
          // Use realIndex when loop is enabled, otherwise use activeIndex
          var activeIndex = (this.params && this.params.loop && typeof this.realIndex !== 'undefined')
            ? this.realIndex
            : (this.activeIndex || 0);
          // Thumbnail index matches slide index (1:1 mapping)
          updateThumbnailActive(activeIndex, true); // Enable scroll on slide change
        };

        window.pdpSlider.on('slideChange', sliderChangeHandler);

        // Set initial active thumbnail after a short delay to ensure Swiper is ready
        setTimeout(function() {
          if (window.pdpSlider) {
            var initialIndex = (window.pdpSlider.params && window.pdpSlider.params.loop && typeof window.pdpSlider.realIndex !== 'undefined')
              ? window.pdpSlider.realIndex
              : (window.pdpSlider.activeIndex || 0);
            updateThumbnailActive(initialIndex, false); // Disable scroll on initialization
          }
        }, 100);
      }
    }, 300);
  }

  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProThumbnails);
  } else {
    initProThumbnails();
  }

  // Handle window resize to prevent breaking on desktop
  var resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      var isDesktop = window.innerWidth >= 981;
      var gridIsActive = proThumbnailInstance !== null && window.proThumbnail !== null;

      // If resized to mobile, clean up desktop instance immediately
      if (!isDesktop && gridIsActive) {
        cleanupProThumbnails();
        return;
      }

      // If on desktop and grid is active, update instance
      if (isDesktop && gridIsActive) {
        // Update the Swiper instance to recalculate dimensions
        proThumbnailInstance.update();

        // Ensure wrapper styles are maintained after resize
        var thumbnailContainer = document.querySelector('.js-pdp-pro .js__pdp-thumbnail-slider');
        if (thumbnailContainer) {
          var wrapper = thumbnailContainer.querySelector('.swiper-wrapper');
          if (wrapper) {
            wrapper.style.transform = 'none !important';
            wrapper.style.transition = 'none';
          }
        }
      } else if (isDesktop && !gridIsActive) {
        // If on desktop but grid is not active, try to initialize
        initProThumbnails();
      }
    }, 250);
  });
})();

(function() {
  var toggleButtonHandler = null;

  function initThumbnailToggle() {
    var toggleButton = document.querySelector('.js-pdp-pro .pdp-pro-thumbnail-toggle');
    var thumbnailContainer = document.querySelector('.js-pdp-pro .outer-pdp-thumbnail-slider');

    if (!toggleButton || !thumbnailContainer) {
      return;
    }

    // Only setup if grid is active (checked by parent script)
    var gridIsActive = window.proThumbnail !== null && window.proThumbnail !== undefined;
    if (!gridIsActive) {
      return;
    }

    // Remove any existing event listener by cloning the button
    if (toggleButtonHandler) {
      var oldToggleButton = toggleButton;
      toggleButton = toggleButton.cloneNode(true);
      oldToggleButton.parentNode.replaceChild(toggleButton, oldToggleButton);
      toggleButtonHandler = null;
    }

    // Ensure aria-controls target id is set on the container
    if (!thumbnailContainer.id) {
      thumbnailContainer.id = 'pdp-pro-thumbnail-gallery';
    }

    // Toggle functionality
    toggleButtonHandler = function(e) {
      // Prevent event bubbling and ensure we catch all clicks on button and children
      e.preventDefault();
      e.stopPropagation();

      if (thumbnailContainer.classList.contains('collapsed')) {
        // Snapshot first currently-hidden thumbnail BEFORE expanding so we
        // can move focus to it. Toggle button sits below the gallery in DOM,
        // so without this, Tab after activation skips the revealed content.
        var firstHidden = null;
        var slides = thumbnailContainer.querySelectorAll('.pdp-thumbnail .swiper-slide');
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].offsetParent === null) {
            firstHidden = slides[i];
            break;
          }
        }

        // Expand
        thumbnailContainer.classList.remove('collapsed');
        thumbnailContainer.classList.add('expanded');
        toggleButton.classList.add('expanded');
        toggleButton.setAttribute('aria-expanded', 'true');

        if (firstHidden) {
          var focusSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
          var focusable = firstHidden.matches(focusSelector) ? firstHidden : firstHidden.querySelector(focusSelector);
          if (focusable) focusable.focus();
        }
      } else {
        // Collapse - ONLY scroll to top when explicitly collapsing via button click
        thumbnailContainer.classList.remove('expanded');
        thumbnailContainer.classList.add('collapsed');
        toggleButton.classList.remove('expanded');
        toggleButton.setAttribute('aria-expanded', 'false');

        // Scroll to the top of the page (only on collapse action)
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };

    toggleButton.addEventListener('click', toggleButtonHandler);
  }

  // Listen for grid initialization event (dispatched by grid script)
  window.addEventListener('proGridInitialized', function() {
    initThumbnailToggle();
  });
})();

(function() {
  function initSupplementFactsModal() {
    var modal = document.getElementById('modal-supplement-facts');
    var triggers = document.querySelectorAll('.js__supplement-facts-trigger');
    var closeBtn = document.querySelector('.js__supplement-facts-close');

    if (!modal || triggers.length === 0) return;

    function openModal() {
      modal.style.display = 'flex';
      // Add class after a small delay to trigger CSS transition
      setTimeout(function() {
        modal.classList.add('modal-opened');
      }, 10);
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
    }

    function closeModal() {
      modal.classList.remove('modal-opened');
      // Wait for transition to complete before hiding
      setTimeout(function() {
        modal.style.display = 'none';
      }, 300);
      document.body.style.overflow = ''; // Restore scrolling
    }

    // Open modal when trigger is clicked
    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openModal();
      });
    });

    // Close modal when close button is clicked
    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
    }

    // Close modal when clicking outside the modal content
    modal.addEventListener('click', function(event) {
      // Check if click is on the modal overlay (not on modal-content or its children)
      if (event.target === modal || !event.target.closest('.modal-content')) {
        closeModal();
      }
    });

    // Close modal on ESC key press
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('modal-opened')) {
        closeModal();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSupplementFactsModal);
  } else {
    initSupplementFactsModal();
  }
})();

(function() {
  var DESKTOP_BREAKPOINT = 981;
  var MAX_FONT_SIZE = 32;
  var resizeTimeout;

  function getMinFontSize(productEl) {
    var raw = productEl.style.getPropertyValue('--mobile-title-font-size') || '';
    var n = parseInt(raw, 10);
    if (isNaN(n) || n < 1) return MAX_FONT_SIZE;
    return Math.min(MAX_FONT_SIZE, Math.max(1, n));
  }

  function fitTitles() {
    var productEl = document.querySelector('.js-pdp-pro');
    if (!productEl) return;

    var titles = productEl.querySelectorAll('.product-title');
    if (!titles.length) return;

    var isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;

    titles.forEach(function(title) {
      if (isDesktop) {
        title.style.fontSize = '';
        title.style.whiteSpace = '';
        return;
      }

      var minSize = getMinFontSize(productEl);

      if (minSize >= MAX_FONT_SIZE) {
        title.style.fontSize = '';
        title.style.whiteSpace = '';
        return;
      }

      var available = title.clientWidth;
      if (!available) return;

      var prevWhiteSpace = title.style.whiteSpace;
      title.style.fontSize = MAX_FONT_SIZE + 'px';
      title.style.whiteSpace = 'nowrap';
      var natural = title.scrollWidth;
      title.style.whiteSpace = prevWhiteSpace;

      if (natural <= available) {
        title.style.fontSize = '';
        return;
      }

      var fitted = Math.floor(MAX_FONT_SIZE * available / natural);
      title.style.fontSize = Math.max(minSize, fitted) + 'px';
    });
  }

  function scheduleFit() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(fitTitles, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fitTitles);
  } else {
    fitTitles();
  }
  window.addEventListener('resize', scheduleFit);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(fitTitles);
  }
})();

(function () {
  function bindThumbAutoScroll() {
    if (!document.querySelector('.js-pdp-pro')) return;
    // Configure once regardless of viewport. The spaceBetween: 0 and
    // syncThumb only have visible effect at mobile where the horizontal
    // thumb swiper renders; at desktop the grid-mode CSS replaces the
    // swiper with a 2-col tile grid and the pro custom JS handles
    // its own sync, so this binding is a no-op there.
    var mainEl = document.querySelector('.js-pdp-pro .js__pdp-slider');
    var thumbEl = document.querySelector('.js-pdp-pro .js__pdp-thumbnail-slider');
    var main = mainEl && mainEl.swiper;
    var thumb = thumbEl && thumbEl.swiper;
    if (!main || !thumb) return setTimeout(bindThumbAutoScroll, 200);
    if (main.__proThumbAutoScrollBound) return;
    main.__proThumbAutoScrollBound = true;

    // Remove the inter-slide margin. Calling update() recomputes slidesGrid
    // so Swiper's own translate math stays consistent with the rendered DOM.
    thumb.params.spaceBetween = 0;
    thumb.update();

    function syncThumb() {
      var idx = (main.params && main.params.loop && typeof main.realIndex !== 'undefined')
        ? main.realIndex
        : (main.activeIndex || 0);
      // Native Swiper snap — brings the active thumb fully into view.
      thumb.slideTo(idx);
    }

    main.on('slideChange', syncThumb);
    syncThumb();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindThumbAutoScroll);
  } else {
    bindThumbAutoScroll();
  }
})();

(function () {
  function initGridCollapseToggle() {
    var product = document.querySelector('.js-pdp-pro.gallery-layout--grid.collapse-toggle-enabled');
    if (!product) return;
    if (window.innerWidth < 981) return;

    var toggleButton = product.querySelector('.pdp-pro-thumbnail-toggle');
    var container = product.querySelector('.outer-pdp-thumbnail-slider');
    if (!toggleButton || !container) return setTimeout(initGridCollapseToggle, 200);
    if (toggleButton.__gridCollapseBound) return;
    toggleButton.__gridCollapseBound = true;

    // Initial state: collapsed. Slider-mode JS adds grid-active for slider;
    // we add it here for grid mode so the visibility CSS rule fires.
    container.classList.add('grid-collapsed');
    toggleButton.classList.add('grid-active');
    if (!container.id) container.id = 'pdp-pro-thumbnail-gallery';

    toggleButton.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (container.classList.contains('grid-collapsed')) {
        // Snapshot first hidden thumb BEFORE expanding (toggle sits
        // below gallery, so Tab from it would skip revealed content).
        var firstHidden = null;
        var slides = container.querySelectorAll('.pdp-thumbnail .swiper-slide');
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].offsetParent === null) { firstHidden = slides[i]; break; }
        }

        container.classList.remove('grid-collapsed');
        toggleButton.classList.add('expanded');
        toggleButton.setAttribute('aria-expanded', 'true');

        if (firstHidden) {
          var focusSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
          var focusable = firstHidden.matches(focusSelector) ? firstHidden : firstHidden.querySelector(focusSelector);
          if (focusable) focusable.focus();
        }
      } else {
        container.classList.add('grid-collapsed');
        toggleButton.classList.remove('expanded');
        toggleButton.setAttribute('aria-expanded', 'false');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGridCollapseToggle);
  } else {
    initGridCollapseToggle();
  }
})();
